// src/HorseDetail.js
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db, auth } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { QRCodeCanvas } from "qrcode.react";

export default function HorseDetail() {
  const { id } = useParams();
  const [horse, setHorse] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ Track login state
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  // ✅ Fetch horse
  useEffect(() => {
    const fetchHorse = async () => {
      try {
        const docRef = doc(db, "horses", id);
        const snapshot = await getDoc(docRef);
        if (snapshot.exists()) {
          setHorse({ id: snapshot.id, ...snapshot.data() });
        } else {
          setHorse(null);
        }
      } catch (err) {
        console.error("Error fetching horse:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchHorse();
  }, [id]);

  if (loading) return <p style={{ textAlign: "center" }}>⏳ Loading...</p>;
  if (!horse) return <p style={{ textAlign: "center", color: "red" }}>❌ Horse not found</p>;

  const isOwner = user && horse.owner === user.uid;

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "2rem auto",
        padding: "2rem",
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
      }}
    >
      {/* ✅ Horse image */}
      {horse.imageUrl && (
        <div style={{ textAlign: "center", marginBottom: "1rem" }}>
          <img
            src={horse.imageUrl}
            alt={horse.name}
            style={{ maxWidth: "100%", borderRadius: "8px" }}
          />
        </div>
      )}

      {/* ✅ Horse info */}
      <h2 style={{ textAlign: "center" }}>{horse.name}</h2>
      <p><strong>Owner:</strong> {horse.ownername}</p>
      <p><strong>Contact:</strong> {horse.contact}</p>
      <p><strong>Age:</strong> {horse.age}</p>
      <p><strong>Breed:</strong> {horse.breed}</p>
      <p><strong>Description:</strong> {horse.description}</p>

      {/* ✅ Show edit button only for owner */}
      {isOwner && (
        <div style={{ textAlign: "center", marginTop: "1rem" }}>
          <Link
            to={`/edit/${id}`}
            style={{
              padding: "0.5rem 1rem",
              background: "blue",
              color: "white",
              textDecoration: "none",
              borderRadius: "6px",
            }}
          >
            ✏️ Edit Horse
          </Link>
        </div>
      )}

      {/* ✅ Always show QR code (for public sharing) */}
      <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
        <QRCodeCanvas
          value={`${window.location.origin}/horse/${id}`}
          size={120}
        />
        <p style={{ marginTop: "0.5rem", fontSize: "0.9rem" }}>Scan for this profile</p>
      </div>
    </div>
  );
}
